/* eslint-disable max-len */
export enum frameworkRoute {
  GRI = 'GRI',
  BRSR = 'BRSR',
  SASB = 'SASB',
  TCFD = 'TCFD',
  CDP_SME = 'CDP_SME',
  CDP_CORPORATE = 'CDP_CORPORATE',
  CBAM = 'CBAM',
  CBAM_IRON_AND_STEEL = 'CBAM'
}

export enum pillarRoutes {
  GENERAL = 'general',
  ENV = 'environmental',
  SOCIAL = 'social',
  GOV = 'governance',
  SECTIONA = 'sectionA',
  SECTIONB = 'sectionB',
  SECTIONC = 'sectionC',
  REAL_ESTATE = 'realEstate',
  SOFTWARE = 'IT',
  AUTO = 'automotive',
  STARTEGY = 'strategy',
  RISK_MANAGEMENT = 'riskManagement',
  MATRICS_TARGETS = 'matricsAndTargets',
  SME_INTRODUCTION = 'SME Introduction',
  SME_MANAGEMENT = 'SME Identification, Assessment',
  SME_DISCLOSURE = 'SME Disclosure of Risks and Opportunities',
  SME_GOVERNANCE = 'SME Governance',
  BUSINESS_STRATEGY = 'SME Business Strategy',
  PERFORMANCE_CONSOLIDATION_APPROACH = 'SME Environmental Performance - Consolidation Approach',
  PERFORMANCE_CLIMATE_CHANGE = 'SME Environmental Performance - Climate Change',
  SME_SIGN_OFF = 'SME Sign Off',
  CORPORATE_INTRODUCTION = 'corporateIntroduction',
  CORPORATE_MANAGEMENT = 'corporateIdentificationAssessmentAndManagementOfDependenciesImpactsRisksAndOpportunities',
  CORPORATE_DISCLOSURE = 'corporateDisclosureofRisksandOpportunities',
  CORPORATE_GOVERNANCE = 'corporateGovernance',
  CORPORATE_STRATEGY = 'corporateBusinessStrategy',
  CORPORATE_PERFORMANCE_CONSOLIDATION_APPROACH = 'corporateEnvironmentalPerformanceConsolidationApproach',
  CORPORATE_PERFORMANCE_CLIMATE_CHANGE = 'corporateEnvironmentalPerformanceClimateChange',
  CORPORATE_ENVIRONMENTAL_PERFORMANCE_FORESTS = 'corporateEnvironmentalPerformanceForests',
  CORPORATE_ENVIRONMENTAL_PERFORMANCE_WATER_SECURITY = 'corporateEnvironmentalPerformanceWaterSecurity',
  CORPORATE_ENVIRONMENTAL_PERFORMANCE_PLASTICS = 'corporateEnvironmentalPerformancePlastics',
  CORPORATE_ENVIRONMENTAL_PERFORMANCE_BIO_DIVERSITY = 'corporateEnvironmentalPerformanceBiodiversity',
  CORPORATE_ENVIRONMENTAL_PERFORMANCE_FINANCIAL_SERVICES = 'corporateEnvironmentalPerformanceFinancialServices',
  CORPORATE_FURTHER_INFORMATION_AND_SIGN_OFF = 'corporateFurtherInformationAndSignOff',
  SECTION_1_EXPORTER_AND_INSTALLATION_PROFILE = 'section1ExporterAndInstallationProfile',
  SECTION_2_ACTIVITY_DATA_AND_PRODUCTION_SYSTEM_BOUNDARY = 'section2ActivityDataAndProductionSystemBoundary',
  SECTION_3_DIRECT_EMBEDDED_EMISSIONS_SCOPE_1 = 'section3DirectEmbeddedEmissionsScope1',
  SECTION_4_INDIRECT_EMBEDDED_EMISSIONS_ELECTRICITY = 'section4IndirectEmbeddedEmissionsElectricity',
  SECTION_5_PRECURSOR_EMISSIONS = 'section5PrecursorEmissions',
  SECTION_6_METHODOLOGY_DATA_QUALITY_VERIFICATION = 'section6MethodologyDataQualityVerification',
  SECTION_7_EMISSION_SUMMARY_AND_EXPORT_SPECIFIC_OUTPUT = 'section7EmissionSummaryAndExportSpecificOutput',
  SECTION_1_PLANT_AND_PRODUCTION_INFORMATION = 'section1PlantAndProductionInformation',
  SECTION_2_SOURCE_STREAM_AND_DIRECT_EMISSIONS_DATA = 'section2SourceStreamAndDirectEmissionsData',
  SECTION_3_ELECTRICITY_AND_INDIRECT_EMISSIONS = 'section3ElectricityAndIndirectEmissions',
  SECTION_4_PROCESS_LEVEL_PRODUCTION_AND_EMISSIONS_DATA = 'section4ProcessLevelProductionAndEmissionsData',
  SECTION_5_PRECURSOR_PURCHASED_INPUT_EMISSIONS_DATA = 'section5PrecursorPurchasedInputEmissionsData',
  SECTION_6_CARBON_PRICING_AND_TAX_ADJUSTMENT = 'section6CarbonPricingAndTaxAdjustment',
  SECTION_7_SHIPMENT_AND_CUSTOMS_INFORMATION = 'section7ShipmentAndCustomsInformation',
  IRON_AND_STEEL = 'ironAndSteel'
}

export const frameworkSubRoutes = {
  GRI: {
    general: `${frameworkRoute.GRI}/${pillarRoutes.GENERAL}`,
    environmental: `${frameworkRoute.GRI}/${pillarRoutes.ENV}`,
    social: `${frameworkRoute.GRI}/${pillarRoutes.SOCIAL}`,
    governance: `${frameworkRoute.GRI}/${pillarRoutes.GOV}`
  },
  BRSR: {
    section_a: `${frameworkRoute.BRSR}/${pillarRoutes.SECTIONA}`,
    section_b: `${frameworkRoute.BRSR}/${pillarRoutes.SECTIONB}`,
    section_c: `${frameworkRoute.BRSR}/${pillarRoutes.SECTIONC}`
  },
  SASB: {
    realEstate: `${frameworkRoute.SASB}/${pillarRoutes.REAL_ESTATE}`,
    IT: `${frameworkRoute.SASB}/${pillarRoutes.ENV}`,
    automotive: `${frameworkRoute.SASB}/${pillarRoutes.GOV}`
  },
  TCFD: {
    governance: `${frameworkRoute.TCFD}/${pillarRoutes.GOV}`,
    strategy: `${frameworkRoute.TCFD}/${pillarRoutes.STARTEGY}`,
    risk_management: `${frameworkRoute.TCFD}/${pillarRoutes.RISK_MANAGEMENT}`,
    matrics_targets: `${frameworkRoute.TCFD}/${pillarRoutes.MATRICS_TARGETS}`
  },
  CDP_SME: {
    smeIntroduction: `${frameworkRoute.CDP_SME}/${pillarRoutes.SME_INTRODUCTION}`,
    smeManagement: `${frameworkRoute.CDP_SME}/${pillarRoutes.SME_MANAGEMENT}`,
    smeDisclosure: `${frameworkRoute.CDP_SME}/${pillarRoutes.SME_DISCLOSURE}`,
    smeGovernance: `${frameworkRoute.CDP_SME}/${pillarRoutes.SME_GOVERNANCE}`,
    businessStrategy: `${frameworkRoute.CDP_SME}/${pillarRoutes.BUSINESS_STRATEGY}`,
    performanceConsolidationApproach: `${frameworkRoute.CDP_SME}/${pillarRoutes.PERFORMANCE_CONSOLIDATION_APPROACH}`,
    performanceClimateChange: `${frameworkRoute.CDP_SME}/${pillarRoutes.PERFORMANCE_CLIMATE_CHANGE}`,
    smeSignOff: `${frameworkRoute.CDP_SME}/${pillarRoutes.SME_SIGN_OFF}`
  },
  CDP_CORPORATE: {
    corporateIntroduction: `${frameworkRoute.CDP_CORPORATE}/${pillarRoutes.CORPORATE_INTRODUCTION}`,
    corporateManagement: `${frameworkRoute.CDP_CORPORATE}/${pillarRoutes.CORPORATE_MANAGEMENT}`,
    corporateDisclosure: `${frameworkRoute.CDP_CORPORATE}/${pillarRoutes.CORPORATE_DISCLOSURE}`,
    corporateGovernance: `${frameworkRoute.CDP_CORPORATE}/${pillarRoutes.CORPORATE_GOVERNANCE}`,
    corporateStrategy: `${frameworkRoute.CDP_CORPORATE}/${pillarRoutes.CORPORATE_STRATEGY}`,
    corporatePerformanceConsolidationApproach: `${frameworkRoute.CDP_CORPORATE}/${pillarRoutes.CORPORATE_PERFORMANCE_CONSOLIDATION_APPROACH}`,
    corporatePerformanceClimateChange: `${frameworkRoute.CDP_CORPORATE}/${pillarRoutes.CORPORATE_PERFORMANCE_CLIMATE_CHANGE}`,
    corporateEnvironmentalPerformanceForests: `${frameworkRoute.CDP_CORPORATE}/${pillarRoutes.CORPORATE_ENVIRONMENTAL_PERFORMANCE_FORESTS}`,
    corporateEnvironmentalPerformanceWaterSecurity: `${frameworkRoute.CDP_CORPORATE}/${pillarRoutes.CORPORATE_ENVIRONMENTAL_PERFORMANCE_WATER_SECURITY}`,
    corporateEnvironmentalPerformancePlastics: `${frameworkRoute.CDP_CORPORATE}/${pillarRoutes.CORPORATE_ENVIRONMENTAL_PERFORMANCE_PLASTICS}`,
    corporateEnvironmentalPerformanceBiodiversity: `${frameworkRoute.CDP_CORPORATE}/${pillarRoutes.CORPORATE_ENVIRONMENTAL_PERFORMANCE_BIO_DIVERSITY}`,
    corporateEnvironmentalPerformanceFinancialServices: `${frameworkRoute.CDP_CORPORATE}/${pillarRoutes.CORPORATE_ENVIRONMENTAL_PERFORMANCE_FINANCIAL_SERVICES}`,
    corporateFurtherInformationAndSignOff: `${frameworkRoute.CDP_CORPORATE}/${pillarRoutes.CORPORATE_FURTHER_INFORMATION_AND_SIGN_OFF}`
  },
  CBAM: {
    section1ExporterAndInstallationProfile: `${frameworkRoute.CBAM}/${pillarRoutes.SECTION_1_EXPORTER_AND_INSTALLATION_PROFILE}`,
    section2ActivityDataAndProductionSystemBoundary: `${frameworkRoute.CBAM}/${pillarRoutes.SECTION_2_ACTIVITY_DATA_AND_PRODUCTION_SYSTEM_BOUNDARY}`,
    section3EmissionFactorsAndEmissionsScope1: `${frameworkRoute.CBAM}/${pillarRoutes.SECTION_3_DIRECT_EMBEDDED_EMISSIONS_SCOPE_1}`,
    section4IndirectEmbeddedEmissionsElectricity: `${frameworkRoute.CBAM}/${pillarRoutes.SECTION_4_INDIRECT_EMBEDDED_EMISSIONS_ELECTRICITY}`,
    section5PrecursorEmissions: `${frameworkRoute.CBAM}/${pillarRoutes.SECTION_5_PRECURSOR_EMISSIONS}`,
    section6MethodologyDataQualityVerification: `${frameworkRoute.CBAM}/${pillarRoutes.SECTION_6_METHODOLOGY_DATA_QUALITY_VERIFICATION}`,
    section7EmissionSummaryAndExportSpecificOutput: `${frameworkRoute.CBAM}/${pillarRoutes.SECTION_7_EMISSION_SUMMARY_AND_EXPORT_SPECIFIC_OUTPUT}`
  },

  CBAM_IRON_AND_STEEL: {
    section1PlantAndProductionInformation: `${frameworkRoute.CBAM_IRON_AND_STEEL}/${pillarRoutes.SECTION_1_PLANT_AND_PRODUCTION_INFORMATION}`,
    section2SourceStreamAndDirectEmissionsData: `${frameworkRoute.CBAM_IRON_AND_STEEL}/${pillarRoutes.SECTION_2_SOURCE_STREAM_AND_DIRECT_EMISSIONS_DATA}`,
    section3ElectricityAndIndirectEmissions: `${frameworkRoute.CBAM_IRON_AND_STEEL}/${pillarRoutes.SECTION_3_ELECTRICITY_AND_INDIRECT_EMISSIONS}`,
    section4ProcessLevelProductionAndEmissionsData: `${frameworkRoute.CBAM_IRON_AND_STEEL}/${pillarRoutes.SECTION_4_PROCESS_LEVEL_PRODUCTION_AND_EMISSIONS_DATA}`,
    section5PrecursorPurchasedInputEmissionsData: `${frameworkRoute.CBAM_IRON_AND_STEEL}/${pillarRoutes.SECTION_5_PRECURSOR_PURCHASED_INPUT_EMISSIONS_DATA}`,
    section6CarbonPricingAndTaxAdjustment: `${frameworkRoute.CBAM_IRON_AND_STEEL}/${pillarRoutes.SECTION_6_CARBON_PRICING_AND_TAX_ADJUSTMENT}`,
    section7ShipmentAndCustomsInformation: `${frameworkRoute.CBAM_IRON_AND_STEEL}/${pillarRoutes.SECTION_7_SHIPMENT_AND_CUSTOMS_INFORMATION}`
  }
};

export enum subCategoryConstants {
  IRON_AND_STEEL_SUB_CATEGORY = 75,
  CEMENT_SUB_CATEGORY = 79
}
